export default __webpack_public_path__ + "static/media/liveInstructor2.cf94a50a.png";